import React from 'react'
import { Link } from 'react-router-dom';
import { Card,Typography,CardMedia,CardContent } from '@mui/material'
import { demoChannelTitle, demoChannelUrl,demoThumbnailUrl,demoVideoTitle,demoVideoUrl} from '../utils/constant'
import { CheckCircle } from '@mui/icons-material';
// destructring the prop here helped me to handled undefined case which leads that every
// time card link is demoVideoUrl
const Video = ({e:{id:{videoId},snippet},idx}) => {
  return (
    
    <Card key={idx}   sx={{maxWidth:350  ,width:{xs:'100%',sm:'358px',md:'320px'}}}>
         <Link to={videoId? `/video/${videoId}`: demoVideoUrl}>
      <CardMedia
         component="img"
        image={snippet?.thumbnails?.high?.url || demoThumbnailUrl}
        alt="Paella dish"
        sx={{width:{xs:'100%',sm:'358px',md:'320px'},height:180}}
      />
    </Link>
      <CardContent>
        <Link  to={videoId? `/video/${videoId}`: demoVideoUrl}>
        <Typography variant='body1' color="text.primary">
          {snippet?.title || demoVideoTitle}
        </Typography>
        </Link>
        <Link to={videoId?`/channel/${snippet?.channelId}`:demoChannelUrl}>
        <Typography variant="body2" color="text.secondary" >
        {snippet?.channelTitle || demoChannelTitle}
       


         <CheckCircle sx={{ml:'15px',fontSize:14,color:'black'}}  />

       
        </Typography>
       

        </Link>
      </CardContent>
    </Card>
  )
}

export default Video